var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexcharts',{staticClass:"chart-width uk-position-bottom-center",attrs:{"height":_vm.getChartHeight,"type":"bar","options":_vm.getChartOptions,"series":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }